import React from 'react';
import PageHeader from 'components/PageHeader';
import { useAboutPageData } from 'hooks/useAboutPageData';
import ContainerLayout from 'layouts/ContainerLayout';
import ErrorLayout from 'layouts/ErrorLayout';
import LoadingLayout from 'layouts/LoadingLayout';
import Experience from 'pages/About/Experience';
import Skills from 'pages/About/Skills';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/system';

const About: React.FunctionComponent = () => {
  const { data, error, loading } = useAboutPageData();
  const { t } = useTranslation();

  return (
    <ContainerLayout>
      <PageHeader>{t('about.title')}</PageHeader>
      <LoadingLayout loading={loading}>
        <ErrorLayout data={data} error={error}>
          <Box>
            {data && (
              <Box>
                <Experience
                  bio={data.bio}
                  experience={data.experience}
                  education={data.education}
                />
                <Skills skills={data.skills} languages={data.languages} />
              </Box>
            )}
          </Box>
        </ErrorLayout>
      </LoadingLayout>
    </ContainerLayout>
  );
};

export default About;
